import { FavoritePriceShowAs } from "../../../types/IFavoriteOrigins";

export const formatPrice = (value: number | null) => {
  if (value === null || value === undefined) {
    return "–";
  }

  return `$${value}`;
};

export function parsePriceInput(raw: string | undefined): number | null {
  if (raw === undefined) {
    return null;
  }
  const normalized = raw.replace(/[^0-9.-]/g, "").trim();
  if (!normalized) {
    return null;
  }
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export const formatPriceByShowAs = (
  value: number | null,
  showAs: FavoritePriceShowAs | null,
) => {
  if (showAs === "DISCUSS") {
    return "Discuss";
  }
  if (showAs === "NO_OFFER") {
    return "No Offer";
  }
  return formatPrice(value);
};
